import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import CloneApkVersionInfo from './submodules/clone';
import CreateApkVersionInfo from './submodules/create';
import ListApkVersionInfo from './submodules/list';
import EditApkVersionInfo from './submodules/edit';

const ApkVersionDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].getApkVersions]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListApkVersionInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addApkVersion]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/clone`}
				component={CloneApkVersionInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].addApkVersion]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateApkVersionInfo}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.apkUpdateInfo}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.apkUpdateInfo].updateApkVersion]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={EditApkVersionInfo}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default ApkVersionDashboard;
